import { createSelector } from "reselect";

import { forEach } from "lodash";

function selectFilteredJobs(
    jobTitle,
    careerCluster,
    jobDescription,
    isGreen,
    isBright,
    am,
    wd,
    gl,
    at,
    bw,
    wo,
    searchtype,
    jobs
) {
    // console.log(
    //     jobTitle,
    //     careerCluster,
    //     jobDescription,
    //     am,
    //     wd,
    //     gl,
    //     at,
    //     bw,
    //     wo
    // );
    // if (
    //     jobTitle === "" &&
    //     careerCluster === "" &&
    //     jobDescription === "" &&
    //     am === "" &&
    //     wd === "" &&
    //     gl === "" &&
    //     at === "" &&
    //     bw === "" &&
    //     wo === ""
    // )
    // return [];
    // console.log(jobs);
    let filtered_jobs = jobs
        .filter(
            (job) =>
                job.job_title.toLowerCase().indexOf(jobTitle.toLowerCase()) !==
                    -1 || job.soc_code.startsWith(jobTitle)
        )
        .filter(
            (job) =>
                careerCluster === "" ||
                (job.clusters && job.clusters.includes(careerCluster))
        )
        .filter(
            (job) =>
                job.job_desc
                    .toLowerCase()
                    .indexOf(jobDescription.toLowerCase()) !== -1
        )
        .filter((job) => (isGreen ? job.is_green === isGreen : true))
        .filter((job) => (isBright ? job.is_bright === isBright : true));

    let min_range = 0,
        max_range = 0;
    switch (searchtype) {
        case 1:
            // Best Match
            min_range = -1;
            break;
        case 2:
            // Exact Match
            break;
        case 3:
            // Better Jobs
            max_range = 1;
            break;
        case 4:
            // All qualified
            min_range = -7;
            break;
        case 5:
            // Higher Skilled
            min_range = 1;
            max_range = 7;
            break;
        default:
            break;
    }

    let skills = { am, wd, gl, at, bw, wo };

    forEach(skills, (val, skill_tag) => {
        if (val !== "") {
            val = parseInt(val, 10);
            let min = val + min_range;
            let max = val + max_range;
            filtered_jobs = filtered_jobs.filter(
                (job) => job[skill_tag] >= min && job[skill_tag] <= max
            );
        }
    });

    return filtered_jobs;
}

function selectSelectedJob(jobs, selectedIndex) {
    if (selectedIndex === null) return null;
    if (selectedIndex >= jobs.length) selectedIndex = 0;
    if (selectedIndex < 0) selectedIndex = jobs.length - 1;

    return jobs[selectedIndex];
}

const jobTitleSelector = (state) => state.jobTitle;
const careerClusterSelector = (state) => state.careerCluster;
const jobDescriptionSelector = (state) => state.jobDescription;
const isGreenSelector = (state) => state.isGreen;
const isBrightSelector = (state) => state.isBright;
const amSelector = (state) => state.am;
const wdSelector = (state) => state.wd;
const glSelector = (state) => state.gl;
const riSelector = (state) => state.ri;
const liSelector = (state) => state.li;
const atSelector = (state) => state.at;
const bwSelector = (state) => state.bw;
const woSelector = (state) => state.wo;
const searchtypeSelector = (state) => state.searchtype;
const jobsSelector = (state) => state.jobs;
const selectedIndexSelector = (state) => state.selectedIndex;
const showSkillLevelsSelector = (state) => state.showSkillLevels;
const selectedSkillSelector = (state) => state.selectedSkill;
const videoPlayerVisibleSelector = (state) => state.videoPlayerVisible;

const filteredJobsSelector = createSelector(
    jobTitleSelector,
    careerClusterSelector,
    jobDescriptionSelector,
    isGreenSelector,
    isBrightSelector,
    amSelector,
    wdSelector,
    glSelector,
    atSelector,
    bwSelector,
    woSelector,
    searchtypeSelector,
    jobsSelector,
    (
        jobTitle,
        careerCluster,
        jobDescription,
        isGreen,
        isBright,
        am,
        wd,
        gl,
        at,
        bw,
        wo,
        searchtype,
        jobs
    ) => {
        return selectFilteredJobs(
            jobTitle,
            careerCluster,
            jobDescription,
            isGreen,
            isBright,
            am,
            wd,
            gl,
            at,
            bw,
            wo,
            searchtype,
            jobs
        );
    }
);

const filterSelectedJob = createSelector(
    filteredJobsSelector,
    selectedIndexSelector,
    (jobs, selectedIndex) => {
        return selectSelectedJob(jobs, selectedIndex);
    }
);

export const filteredState = createSelector(
    jobTitleSelector,
    careerClusterSelector,
    jobDescriptionSelector,
    isGreenSelector,
    isBrightSelector,
    amSelector,
    wdSelector,
    glSelector,
    riSelector,
    liSelector,
    atSelector,
    bwSelector,
    woSelector,
    searchtypeSelector,
    jobsSelector,
    selectedIndexSelector,
    showSkillLevelsSelector,
    selectedSkillSelector,
    videoPlayerVisibleSelector,
    filteredJobsSelector,
    filterSelectedJob,
    (
        jobTitle,
        careerCluster,
        jobDescription,
        isGreen,
        isBright,
        am,
        wd,
        gl,
        ri,
        li,
        at,
        bw,
        wo,
        searchtype,
        jobs,
        selectedIndex,
        showSkillLevels,
        selectedSkill,
        videoPlayerVisible,
        filteredJobs,
        selectedJob
    ) => ({
        jobTitle,
        careerCluster,
        jobDescription,
        isGreen,
        isBright,
        am,
        wd,
        gl,
        ri,
        li,
        at,
        bw,
        wo,
        searchtype,
        jobs,
        selectedIndex,
        showSkillLevels,
        selectedSkill,
        videoPlayerVisible,
        filteredJobs,
        selectedJob,
    })
);
